module.exports = __webpack_public_path__ + "static/img/operator.a34dc996.png";